import getApiClient from '@/plugins/api'

export default {

    loadSurveys() {
        const self = this;
        const api = getApiClient(self.$root.$store);

        self.search = {};

        self.$store.commit('startLoading')

        self.search.page = self.page
        self.search.itemsPerPage = self.perPage
        self.surveys = [];

        // GET
        api.get(`/surveys`, {
            params: self.search
        })
            .then((result) => {
                self.surveys = result.data['hydra:member'];
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    changePage: function(page) {
        this.page = page
    },

    closeModals() {
        this.detailedSurvey = {id: null}
        this.showDetailedSurvey = false
    },

    openSurvey: function(survey) {
        this.detailedSurvey = survey
        this.showDetailedSurvey = true
    }

}
